import { Grid2, Typography, Button, Paper, InputBase, Divider } from "@mui/material"
import { useState } from "react";
import validator from "validator";
import { backendHosts } from '../../../../ui-utils/apiConfig'
import Styles from "./Mob.module.css"
import axios from "axios";
import pic from "../../../../ui-utils/latestPics/derivativesTalk.svg"
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/talk.json";
import hi from "../../../../i18n/Hindi/Trade Invest/talk.json";
import kn from "../../../../i18n/Kannada/Trade Invest/talk.json";
import ma from "../../../../i18n/Marathi/Trade Invest/talk.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/talk.json";
export default function DerivativesTalkMob() {
     const [mobileNo, setMobileNo] = useState("");
     const clientErr = {};
     const [mobClientErr, setMobileClientErr] = useState({});
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];
        // const isSmallScreen = useMediaQuery("(max-width:600px)");

        const handleMobilenoEnter = async() => {
            const formData = { mobileNo };
            console.log(formData);
            const runValidation = () => {
                if (mobileNo.trim().length == 0) {
                    clientErr.mobileNo = "Please enter your mobile number.";
                    return;
                }
                if (!validator.isMobilePhone(mobileNo, "en-IN")) {
                    clientErr.mobileNo = "Please enter a valid mobile number.";
                    return;
                }
            };
            runValidation();
            if (Object.keys(clientErr).length == 0) {
                const payload = {
                    data: {
                        mobile: mobileNo
                    }
                }

                const response = await axios.post(`${backendHosts.ADMIN}/api/public/fno_specialist`, payload);
                console.log("result", response.data.data)
                if (response.data.data.status == 200) {
                    setMobileNo("")
                    clientErr.successMessage = "Thank you for reaching out!. One of our representatives will contact you shortly."
                    clientErr.mobileNo = ""
                    setMobileClientErr(clientErr);
                } else {
                    clientErr.mobileNo = response.data.data.data.message
                    clientErr.successMessage = ""
                    setMobileClientErr(clientErr)
                }


            } else {
                setMobileClientErr(clientErr);
            }
        };

        const handleMobileNoChange = (e) => {
            const inputValue = e.target.value;
            const numericValue = inputValue.replace(/\D/g, "");
            const limitedValue = numericValue.slice(0, 10);

            setMobileNo(limitedValue);
        };
    return (
    <>
       <Grid2 className={Styles.outerCard}>

                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <h1 className={Styles.heading}>
                        {t.title}
                    </h1>
                </div>
                <Typography className={Styles.subtitle}>
                    {t.subtitle}
                    </Typography>

                    <Grid2 className={Styles.fieldCard}>

                    <Paper component="form" className={Styles.mobilefield}>
                        <Typography className={Styles.preMobile}>91</Typography>
                        <Divider className={Styles.divider} orientation="vertical" />
                        <InputBase
                            className={Styles.inputbase}
                            placeholder={t.formFields.mobilePlaceholder}
                            onChange={handleMobileNoChange}
                            value={mobileNo}
                        />
                    </Paper>

                    {mobClientErr.mobileNo ? (
                        <Typography className={Styles.errMsgg}>
                            {mobClientErr.mobileNo}
                        </Typography>
                    ) : (
                        mobClientErr.successMessage && (
                            <Typography className={Styles.successMsg}>
                                {mobClientErr.successMessage}
                            </Typography>
                        )
                    )}
                    <Button
                        variant="contained"
                        onClick={handleMobilenoEnter}
                        className={Styles.dematButton}
                    >
                        {t.formFields.buttonText}
                    </Button>
                    <img src={pic} alt="Derivative Talk" className={Styles.pic} />
                </Grid2>

       </Grid2>
    </>
    )
}